// @oasis-permission-inherits: /ai-edits (studio-edits:view)
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_dash/ai-edits/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/ai-edits/all" />;
}
